import { render, staticRenderFns } from "./CopyFromTemplate.vue?vue&type=template&id=2ae1aa74&scoped=true"
import script from "./CopyFromTemplate.vue?vue&type=script&lang=js"
export * from "./CopyFromTemplate.vue?vue&type=script&lang=js"
import style0 from "./CopyFromTemplate.vue?vue&type=style&index=0&id=2ae1aa74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae1aa74",
  null
  
)

export default component.exports